/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { TabContext } from '@material-ui/lab';
import { useQuery } from 'react-apollo';
import { Link } from 'react-router-dom';
import {  Button, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import findCategoryPageByUrl from '../../../../../../../../gql/queries/findCategoryPageByURL';
import ProductItem from '../../../../../../GraphqlCommonComponents/TrendingProducts/Partials/ProductItem';

const MobileContentView = (props) => {
    const { activeTab: { link }, brand, action } = props;
    const currency = 'USD';
    const url = link?.href;
    const PRODUCT_QUERY = findCategoryPageByUrl(brand.domain, url, 'standard_collections', null, null, false, currency, null);
    const { loading, data } = useQuery(PRODUCT_QUERY);
    if (loading) return 'Loading...';
    const { products = [] } = data?.findCategoryPageByUrl?.category || {};
    products.splice(6);
    return (
        <Grid className="tab-content-holder" container>
            <TabContext>
                <Grid
                    container
                    columnSpacing={{
                        xs: 1, sm: 1, md: 3, lg: 4,
                    }}
                    spacing={2}
                    direction="row"
                    justifyContent="center"
                >
                    {products?.map((product, index) => {
                        const itemData = {
                            key: product.id,
                            item: product,
                            index,
                        };
                        return (
                            <Grid item xs={6} sm={6} md={3} lg={3}>
                                <div style={{ cursor: 'pointer', position: 'relative', width: '100%' }}>
                                    <ProductItem item={itemData} isPlantsForOccasions brand={brand} />
                                </div>
                            </Grid>
                        );
                    })}
                </Grid>
                {action
                    && (
                        <div className="shopAllBtnWrapper">
                            <Link
                                to={url}
                            >
                                <Button
                                    key={action?.title}
                                    size="big"
                                    className="shopAllBtn"
                                >
                                    Shop All
                                </Button>
                            </Link>
                        </div>
                    )}
            </TabContext>
        </Grid>
    );
};

MobileContentView.propTypes = {
    activeTab: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
    action: PropTypes.object.isRequired,
};

export default MobileContentView;
